import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { FlexSectionController } from "../../models/flexible/flex-section-controller";
import { PriceType } from "../generated/graphql";
import { FlexSectionSchema } from "./flex-section-schema";

export const isSectionEmbedded = (section: FlexSectionSchema) => !section.isArray && !section.isOptional;

export const combinePaths = (prefix: string | undefined, path: string) => (prefix ? `${prefix}.${path}` : path);

export const isSectionContaining = (sectionController: FlexSectionController, ...attributes: Array<AttributeIdentifiers>): boolean =>
	sectionController.fieldControllers.some((field) => attributes.includes(field.schema.attribute.identifier as AttributeIdentifiers)) ||
	sectionController.sectionControllers.some((nested) => isSectionContaining(nested, ...attributes));

export function mapBasePriceKeys(source: PriceType) {
	switch (source) {
		case PriceType.PublicPricePercent:
			return "public-price";
		case PriceType.ExFactoryPricePercent:
			return "ex-factory-price";
		case PriceType.PublicPrice:
		case PriceType.ExFactoryPrice:
			return "fixed-price";
		default:
			return `price-type-${source}`;
	}
}
